import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { IconWarning } from '../../../../../../../assets/icons';
import { EmptyStateBox } from '../../../../../../../components/empty-state-box';
import { useDevicesAndChannelsContext } from '../../../../../context/devices-and-channels';
import { ChannelType } from '../../../../../types/channel';

type GateCalibrationInfoProps = {
  channel: ChannelType;
};

export const GateCalibrationInfo: React.FC<GateCalibrationInfoProps> = ({ channel }) => {
  const { t } = useTranslation('channel-details');
  const { getDeviceById } = useDevicesAndChannelsContext();

  const model = getDeviceById(channel.deviceId)?.payload.model;

  if (!model) return null;

  return (
    <Box sx={{ my: 3, px: 3, display: 'flex', justifyContent: 'center' }}>
      <EmptyStateBox content={t('gateCalibration.info', { model: t(`gateCalibration.${model}`) })} icon={<IconWarning />} />
    </Box>
  );
};
